import { useState, useEffect, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Button, TableCell, TableHead, TableRow, Typography, Table, TableBody, TableContainer, Paper, TablePagination, Grid } from '@mui/material';
import UsersHeader from './UsersHeader';
import UsersRow from './UsersRow';
import AddUsers from './AddUsers';
import { getUserActions } from '../Admins/AdminHandler'
import { REQUEST_ACTIONS, sendRequest } from '../../utils/Communicator';
import { useSelector, useDispatch } from 'react-redux';
import { onAdminChange, onWarehouseChange } from '../../reducers/admin-reducers/AdminSlicer';
import { snackbarToggle } from '../../reducers/snackbarSlicer';
import { Dialog, Snackbar, DateTimePicker } from '../../style-guide';
import { URL, LANGUAGES } from '../../constants/global-constants';

export const UserActions = () => {
    const dispatch = useDispatch();
    const { adminList, admin, warehouseList, senderList, users } = useSelector(state => state.admin);
    const [userActions, setUserActions] = useState([]);
    const [pageNumber, setPageNumber] = useState(0);
    const [count, setCount] = useState(0);
    const [start, setStart] = useState(0);
    const [end, setEnd] = useState(new Date().getTime());
    const [pageSize, setPageSize] = useState(25);
    const paginationArr = [25, 50, 100]

    const onPageHandleChange = (_, newPage) => {
        setPageNumber(newPage);
    };

    const onRowsPerPageHandleChange = event => {
        setPageSize(+event.target.value)
        setPageNumber(0)
    };
    useEffect(() => {

        getUserActions( admin, pageNumber, pageSize, start, end,
            function (data) {
                console.log(data);
                setCount(data.totalElements);
                setUserActions(data.content);
            })
    }, [pageSize, pageNumber]);

    const getDateTime = (date) => {
        if (!date)
            return "";
        var dt = new Date(Number(date));
        const padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);
        return `${padL(dt.getDate())}/${padL(dt.getMonth() + 1)}/${dt.getFullYear().toString().substr(-2)} ${padL(dt.getHours())}:${padL(dt.getMinutes())}:${ padL(dt.getSeconds())}`;
    }

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <Grid item container xs={12}>
                <Grid item container xs={2} style={{ margin: "5px" }}>
                    <DateTimePicker
                        sm={null}
                        md={null}
                        xs={10}
                        label={<Typography fontSize="12px" >Start Date</Typography>}
                        value={start || ''}
                        onChange={date => setStart(date.getTime())}
                        style={{ 'top': '0', left: '35px', width: '6.3vw', }}
                    />
                </Grid>
                <Grid item container xs={2} style={{ margin: "5px" }}>
                    <DateTimePicker
                        sm={null}
                        md={null}
                        xs={10}
                        label={<Typography fontSize="12px" >End Date</Typography>}
                        value={end || ''}
                        onChange={date => setEnd(date.getTime())}
                        style={{ 'top': '0', left: '35px', width: '6.3vw', }}
                    />
                </Grid>
                <Button variant='contained' onClick={() => {
                    getUserActions(admin, pageNumber, pageSize, start, end,
                        function (data) {
                            console.log(data);
                            setCount(data.totalElements);
                            setUserActions(data.content);
                        })
                }}>
                    Search
                </Button>
            </Grid>
            {userActions.length > 0 && <TableContainer sx={{ height: 'calc(100vh - 200px)' }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={4}>
                                <Typography variant='h7'>
                                    LoginTime
                                </Typography>
                            </TableCell>
                            <TableCell sx={4}>
                                <Typography variant='h7'>
                                    User Name
                                </Typography>
                            </TableCell>
                            <TableCell sx={4}>
                                <Typography variant='h7'>
                                    User IP
                                </Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {userActions?.map(ua => (<TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                            <TableCell>
                                <Typography variant='body1' component='span'>
                                    {getDateTime(ua.actionTime) || '-'}
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant='body1' component='span'>
                                    {adminList.find(ad => ad.id === ua.adminId)?.adminName  || '-'}
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant='body1' component='span'>
                                    {ua.remoteAddr || '-'}
                                </Typography>
                            </TableCell>
                        </TableRow>))}
                    </TableBody>
                </Table>
            </TableContainer>}
            <TablePagination
                rowsPerPageOptions={paginationArr}
                component='div'
                count={count}
                rowsPerPage={pageSize}
                page={pageNumber}
                onPageChange={onPageHandleChange}
                onRowsPerPageChange={onRowsPerPageHandleChange}
            />
        </Paper>


    );
};
export default UserActions;
